import { StoreAddService } from './store-details-wizrd/store-add.service';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { BaseComponent } from '../core/base-component';
import { debounceTime, filter, finalize, map, switchMap, take, tap } from 'rxjs/operators';
import { from, combineLatest, Observable, of, Subject, Subscription } from 'rxjs';
import { StorageService } from '../core/util/storage.service';
import { MapStyleService } from './style/map-style.service';
import { MtnMapOptions } from './mtn-map-options';
import { selectUserState, UserState } from '../auth/user-state';
import { Store as NgrxStore } from '@ngrx/store';
import { AppState } from '../app-state';
import { buildDefaultMapSnapshot, MapSnapshot } from './map-snapshot';
import { FeatureService } from '../core/federation/feature/feature.service';
import { GridAlgorithm, MarkerClusterer } from "@googlemaps/markerclusterer";
import { MtnMap } from './mtn-map';
import {  MapEventType } from './map-events';
import { MapSelectionMode } from './map-selection-mode.enum';
import { FilterGroup } from '../core/federation/filter/filter-group';
import { FeatureRequest } from '../core/federation/feature/feature-request';
import { GeoJsonFilter } from '../core/federation/filter/filter';
import { Pageable } from '../core/service/pageable';
import { FeatureType } from '../core/federation/feature/feature-type.enum';
import { StoreFeatureRequest } from '../core/federation/feature/store-feature-request';
import { Feature } from '../core/models';
import { FilterType } from '../core/federation/filter/filter-type.enum';
import Marker = google.maps.Marker;
import LatLngBounds = google.maps.LatLngBounds;
import { WizardRunnerService } from '../core/wizard/wizard-runner.service';
import { StoreAddWizard } from './store-details-wizrd/store-add-wizard';
import { LowPopulationAlertWizard } from './store-details-wizrd/store-add/low-population-alert/low-population-alert-wizard';
// import * as localForage from "localforage";
// import { PointClickTourWizard } from './store-details-wizrd/store-add/point-cick-tour/point-click-tour-wizard';
import { GeoMatchService } from './store-details-wizrd/store-add/geo-match.service';
import * as localforage from 'localforage';
import { locationAccessDeniedWizard } from './location-access-denied-wizard/location-access-denied-wizard';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'mtn-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent extends BaseComponent implements  OnInit, AfterViewInit, OnDestroy {

  private readonly DEFAULT_CLUSTER_ZOOM = 9;
  @Input()
  options: MtnMapOptions;

  @Output()
  ready = new EventEmitter<MtnMap>(true);

  @ViewChild('mapContainer')
  mapElementRef: ElementRef;

  isFeatureToolbarShown = false;
  isLoadingFeatures = false;
  isLoadingPopulation = false;
  isReady = false;
  map: MtnMap;
  MapSelectionMode = MapSelectionMode;
  markerClusterer: any;
  runningFeatureRequest: Subscription;
  showSelectionAdvice = false;
  showDropPin = false;
  addDropPin = false;
  currentSearchlocation: any;
  private _featureRefresh$ = new Subject<void>();
  private snapshot: MapSnapshot;
  driveTime = 3 ;
  populationLimit = 45;
  private geoJsonLoaded = false;
  previousMarker = [];
  private featureRefreshSubscription: Subscription | null = null;
  private mapEventsSubscription: Subscription | null = null;

  constructor(private featureService: FeatureService,
              private mapStyleService: MapStyleService,
              private storageService: StorageService,
              private storeAddService: StoreAddService,
              private wizardRunner: WizardRunnerService,
              private geoMatchService: GeoMatchService,
              private cdr: ChangeDetectorRef,
              private ngrxStore: NgrxStore<AppState>,
              private zone: NgZone) {
                super();
                this.preloadGeoJson();

  }

  async ngOnInit(){
    // const showPointClickTour = await localForage.getItem(StorageService.SHOW_POINT_CLICK_TOUR);
    // if(showPointClickTour == undefined || showPointClickTour == null ){
    //   localForage.setItem(StorageService.SHOW_POINT_CLICK_TOUR, true);
    // }
  }

  ngAfterViewInit(): void {
    this.initMap()
      .subscribe();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    google.maps.event.clearListeners(this.map, 'bounds_changed');
    google.maps.event.clearListeners(this.map, 'click');
    google.maps.event.clearListeners(this.map, 'maptypeid_changed');
    google.maps.event.clearListeners(this.map, 'overlaycomplete');
    this.map = null;
  }
  private async preloadGeoJson() {
    if (!this.geoJsonLoaded) {
      await this.geoMatchService.loadGeoJson();
      this.geoJsonLoaded = true;
      console.log("✅ geoJson loaded once");
    }
  }
  focusOnMarkers(): void {
    const bounds = new LatLngBounds();

    this.previousMarker.forEach((marker: Marker) => bounds.extend(marker.getPosition()));

    this.map.fitBounds(bounds);
  }

  private createMap(): Observable<MtnMap> {
    return combineLatest([
      this.mapStyleService.currentMessage,
      this.mapStyleService.currentPOI
    ]).pipe(
      switchMap(([msg, poi]) => {
        return this.loadSettingsFromAutoSave().pipe(
          switchMap((snapshot: MapSnapshot) => this.applyDefaultOptions(snapshot)),
          map(() => {
            let mapId = environment.GRAY_SCALE; // Default case: both false

            if (msg && poi) {
              mapId = environment.DARKTHEME_WITH_POI;
            } else if (msg) {
              mapId = environment.DARKTHEME;
            } else if (poi) {
              mapId = environment.GRAYSCALE_WITH_POI;
            }

            return new MtnMap(
              this.mapElementRef.nativeElement,
              this.snapshot,
              mapId
            );
          })
        );
      })
    );
  }



  private getSnapshotStorageKey(): string {
    return `map-snapshot-${this.options.key}`;
  }

  private initMap(): Observable<MtnMap> {
    return this.createMap().pipe(
      map((result: MtnMap) => {
        this.map = result;
        this.autoSave();

        this.ready.emit(this.map);
        this.isReady = true;

        this.buildMarkerClusterer();
        this.subscribeToMapEvents();
        this.subscribeToFeatureRefreshEvents();

        return result;
      })
    );
  }


  private loadSettingsFromAutoSave(): Observable<MapSnapshot> {
    const storageKey = this.getSnapshotStorageKey();
    return this.storageService.get(storageKey)
      .pipe(map((snapshot: MapSnapshot) => {
        if (snapshot) {
          // Clean up legacy styles from cached snapshots
          if (snapshot.options && snapshot.options.styles) {
            delete snapshot.options.styles;
          }
          return new MapSnapshot(snapshot);
        }
        return null;
      }));
  }

  private applyDefaultOptions(preloadedSnapshot: MapSnapshot): Observable<any> {
    //First, load preferences
    return selectUserState(this.ngrxStore)
      .pipe(filter((state: UserState) => !!state.userPreferences))
      .pipe(
        take(1),
        tap((state: UserState) => {
          const defaultMode = state.userPreferences?.mapDefaultMode;
          const defaultType = state.userPreferences?.mapDefaultType;

          //Build a default snapshot
          const snapshot = buildDefaultMapSnapshot(defaultMode, defaultType);

          //If we have a snapshot loaded, apply those to the default
          if (preloadedSnapshot) {
            Object.assign(snapshot, preloadedSnapshot);
          }

          //Finally, if we have options supplied, apply those to the default
          if (this.options) {
            Object.assign(snapshot.options, this.options);
          }

          //Re-apply mode and type settings to ensure consistent behavior
          if (this.options?.mode) {
            snapshot.options.mode = this.options.mode;
          } else {
            snapshot.options.mode = defaultMode;
          }
          if (this.options?.mapTypeId) {
            snapshot.options.mapTypeId = this.options.mapTypeId;
          } else {
            snapshot.options.mapTypeId = defaultType;
          }

          //Apply styles
          //legacy style stop due migrated to  cloud style
          // snapshot.options.styles = this.mapStyleService.buildStyles(snapshot.options);

          //Apply controls settings to proper map settings
          snapshot.options.streetViewControl = snapshot.options.controlConfiguration.isStreetViewEnabled;
          snapshot.options.rotateControl = snapshot.options.controlConfiguration.isTiltAndRotateEnabled;

          this.snapshot = snapshot;
          this.options = snapshot.options;
        })
      );
  }

  private autoSave(): void {
    if (this.map.options.isAutoSaveEnabled && this.isReady) {
      const storageKey = this.getSnapshotStorageKey();

      const snapshot = this.map.snapshot;
      snapshot.options.onMarkerClick = null;

      this.storageService.set(storageKey, snapshot).subscribe();
    }
  }

  private buildMarkerClusterer(): void {

    this.markerClusterer = new  MarkerClusterer({
      map: this.map,
      markers: [],

      algorithm: new GridAlgorithm({
        maxZoom: this.DEFAULT_CLUSTER_ZOOM,
        gridSize: 120,
      }),

    });
  }

  private buildMarkersForFeatures(features: Feature[]): void {
    if(this.previousMarker?.length > 0){
        this.previousMarker.forEach(element => {
          element.map = null;
        });
        this.previousMarker = [];
    }
    if (features?.length) {
      const drawnMarkers:any = this.map.drawMarkers(features,this.map);
      this.previousMarker = drawnMarkers;
      this.markerClusterer.addMarkers(drawnMarkers);
    }
  }

  private clearMarkers(): void {
    this.map.clearMarkers();
    this.markerClusterer.clearMarkers();
    if(this.previousMarker?.length > 0){
      this.previousMarker.forEach(element => {
        element.map = null;
      });
      this.previousMarker = [];
  }
  }

  private loadFeatures(): Observable<any> {
    if (this.map.options.staticFeatures?.length) {
      this.clearMarkers();
      this.zone.run(() => this.buildMarkersForFeatures(this.map.options.staticFeatures));
      return of([]);
    } else if (this.map.options.isFeatureMap && this.map.getZoom() >= 8) {
      this.isLoadingFeatures = true;

      this.clearMarkers();
      return this.loadFeaturesForFilterGroup(this.map.options.filterGroup)
        .pipe(
          finalize(() => this.isLoadingFeatures = false),
          tap((featureResponse: Pageable<Feature>) => {
            if (featureResponse?.content) {
              this.zone.run(() => this.buildMarkersForFeatures(featureResponse.content));
            }
          })
        );
    } else {
      this.markerClusterer.clearMarkers();
      return of([]);
    }
  }

  private loadFeaturesForFilterGroup(filterGroup: FilterGroup): Observable<Pageable<Feature>> {
    filterGroup.clearFilter(FilterType.GEOJSON);

    const geoJsonFilter = new GeoJsonFilter();
    geoJsonFilter.value = this.map.bounds.getFeature().geometry;
    filterGroup.filters.push(geoJsonFilter);

    if (this.map.isFeatureType(FeatureType.SHOPPING_CENTER)) {
      const request = new FeatureRequest();
      request.filterGroup = filterGroup;
      return this.featureService.findAllShoppingCenters(request);
    } else if (this.map.isFeatureType(FeatureType.STORE)) {
      const request = new StoreFeatureRequest();
      request.filterGroup = filterGroup;
      return from(this.prepareStoreRequest(request)).pipe(
        switchMap(updatedRequest => {
          if (!updatedRequest) {
            return of(null);
          }
          return this.featureService.findAllStores(updatedRequest);
        }),
        tap((storeResponse: Pageable<Feature>) => {
          if (storeResponse) {
            // Store total count and full response globally for PDF export
            (window as any).apiStoreTotalCount = storeResponse.totalElements;
            (window as any).apiStoreResponse = storeResponse.content?.map(f => f.properties) || [];
            console.log('API Store Total Count:', storeResponse.totalElements);
            console.log('API Store Response stored:', (window as any).apiStoreResponse.length);
            
            if (storeResponse.content) {
              storeResponse.content.forEach((feature: Feature) => {
                const store = feature.properties?.store;
                if (store && store.volume) {
                  console.log('Store with volume data loaded:', store.name, 'volume:', store.volume);
                }
              });
            }
          }
        })
      );
    } else {
      return of(null);
    }
  }

  async prepareStoreRequest(baseRequest: StoreFeatureRequest): Promise<StoreFeatureRequest | null> {
    const fips: string[] = await localforage.getItem(StorageService.USER_FIPS);
    let polygon = {};
    baseRequest.filterGroup.filters.forEach(element => {
      if(element.type === 'GEOJSON'){
        polygon =  element.value
      }
    });
    baseRequest.filterGroup.filters = baseRequest.filterGroup.filters.filter(
      (f: any) => f.type !== 'FIPS'
    );

    if (fips && fips.length > 0 && polygon) {
      // Only load geoJson if needed
      if (!this.geoJsonLoaded) {
        await this.geoMatchService.loadGeoJson();
        this.geoJsonLoaded = true;
      }

      const matchedFips = this.geoMatchService.getFipsInsidePolygon(polygon, fips);
      console.log("🚀 ~ MapComponent ~ prepareStoreRequest ~ matchedFips:", matchedFips)

      if (!matchedFips || matchedFips.length === 0) {
        // ❌ Prevent API call
        return null;
      }

      baseRequest.filterGroup.filters.push({
        type: 'FIPS',
        value: matchedFips,
      } as any);
    }

    return baseRequest;
  }


  private subscribeToMapEvents(): void {
    // Unsubscribe if already subscribed
    if (this.mapEventsSubscription) {
      this.mapEventsSubscription.unsubscribe();
    }

    // Subscribe and store reference
    this.mapEventsSubscription = this.map.events.subscribe((event: any) => {
      console.log('event',event);

      switch (event.type) {
        case MapEventType.BOUNDS_CHANGE:
          if (this.map.options.isAutoUpdateEnabled) {
            this._featureRefresh$.next();
          }
          if(this.map.getZoom() <= 8){
            this.clearMarkers();
          }
          this.autoSave();
          console.log('Map Zoom Level: ' + this.map.getZoom());
          break;
        case MapEventType.CLICK:
          if (this.map.options._isStoreAdding && this.addDropPin) {
            const latLng = event._payload;
            this.isLoadingPopulation = true;
            this.cdr.detectChanges();
            this.getLocationInfo(latLng.lat, latLng.lng);
            this.toggleDropPin();
            this.showDropPin = false;
          }
          if (this.map.selectionMode !== MapSelectionMode.RING) {
            this.map.select(null);
          }
          break;
        case MapEventType.FILTER_CHANGE:
          this._featureRefresh$.next();
          break;
        case MapEventType.OPTION_CHANGE:
          const options = event.payload;
          this.isFeatureToolbarShown = options?.controlConfiguration.isGoogleSearchEnabled
            || options?.controlConfiguration.isFiltersEnabled;
          this.autoSave();
          break;
        case MapEventType.SELECTION_CHANGE:
          setTimeout(() => {
              const element: any = document.getElementsByClassName('gm-iv-container');
              if (element.length > 0 && element[0].parentNode) {
                element[0].parentNode.style.transform = 'translate(10px, 367px)';

              } else {
                console.warn('Street View container not found yet.');
              }

              const addressEl = document.getElementsByClassName('gm-iv-address');
              if (addressEl.length > 0) {
                  const address = addressEl[0] as HTMLElement;
                  address.style.transform = 'translate(15px, 367px)';
              } else {
                  console.warn('Street View address not found.');
              }


              const elementlink = document.getElementsByClassName('gm-iv-address-link');
              if(elementlink.length > 0)
              {
                const address = elementlink[0] as HTMLElement;
                address.style.transform='translate(-1px,-6px)';
              }
              else {
                  console.warn('Street View address not found.');
              }


              const elementseparator = document.getElementsByClassName('gm-iv-vertical-separator');
              if(elementseparator.length > 0)
              {
                const address = elementseparator[0] as HTMLElement;
                address.style.transform='translate(0px,-10px)';
              }
              else {
                  console.warn('Street View address not found.');
              }
          }, 1000); // delay for 1 second

          this.autoSave();
          break;
        case MapEventType.SELECTION_MODE_CHANGE:
          const selectionMode = event.payload;
          this.showSelectionAdvice = !!selectionMode;
          break;
        default:
          break;
      }
    });
  }

  private getLocationInfo(lat: number, lng: number): void {
    const geocoder = new google.maps.Geocoder();
    const latLng = new google.maps.LatLng(lat, lng);

    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK && results[0]) {
        const address = results[0].formatted_address;
        this.openStoreAddWizard(address,lat,lng);
        // You can also store this information or display it on the map
      } else {
        console.error('Geocoder failed or no results found');
      }
    });
  }

  storeButtonClicked(event:boolean){
    this.showDropPin = event;
    this.toggleDropPin();
    if(!this.showDropPin){
      this.addDropPin = false;
      if(this.map.options.draggableCursor != ''){
        this.map.setOptions({
          draggableCursor: ''
        });
      }
    }
  }

private subscribeToFeatureRefreshEvents(): void {
  // Unsubscribe previous subscription
  if (this.featureRefreshSubscription) {
    this.featureRefreshSubscription.unsubscribe();
  }

  // Subscribe and store reference
  this.featureRefreshSubscription = this._featureRefresh$
    .pipe(debounceTime(500))
    .subscribe(() => {
      if (this.runningFeatureRequest) {
        this.runningFeatureRequest.unsubscribe();
      }

      this.runningFeatureRequest = this.loadFeatures()
        .pipe(finalize(() => {
          this.runningFeatureRequest = null;
        }))
        .subscribe();
    });
}


  toggleDropPin(){
    this.addDropPin = !this.addDropPin;
    if(this.map.options.draggableCursor == ''){
      this.map.setOptions({
        draggableCursor: 'url("/assets/images/location-svg.svg"), auto',
        draggingCursor: 'move',
          });
    }else{
      this.map.setOptions({
        draggableCursor: ''
      });
    }
  }

  async openStoreAddWizard(location: string, lat: number, lng: number) {
    // Check access first
    await this.geoMatchService.loadGeoJson(); // Ensure GeoJSON is loaded
    const result = this.geoMatchService.getLocationInfo(lat, lng);
    this.currentSearchlocation = result;

    const userFips: string[] = await localforage.getItem(StorageService.USER_FIPS) || [];
    console.log('CBSA Code:', result?.cbsa);
    console.log('State FIPS:', result?.stateFips);
    console.log('User FIPS List:', userFips);

    const hasAccess =
      result &&
      (userFips.includes(result.cbsa) || userFips.includes(result.stateFips) || userFips.length === 0);

    if (!hasAccess) {
      const deniedWizard = new locationAccessDeniedWizard();
      await this.wizardRunner.run(deniedWizard).afterClosed().toPromise();
      this.isLoadingPopulation = false;
      this.toggleDropPin();
      this.showDropPin = true;
      return; // Stop execution if no access
    }

    // If access granted, proceed with population check
    this.isLoadingPopulation = true;
    try {
      const result: any = await this.storeAddService.getPopulation(lat, lng, this.driveTime).toPromise();
      this.isLoadingPopulation = false;
      const population = result.currentPopulation;
      await this.openStoreAfterCheckingPopulation(location, lat, lng, population);
    } catch (error) {
      console.error("🚀 ~ MapComponent ~ this.storeAddService.getPopulation ~ error:", error);
      this.isLoadingPopulation = false;
    }
  }

  async openStoreAfterCheckingPopulation(location: string, lat: number, lng: number, population: number) {
    // const showPointClickTour:any = await localForage.getItem(StorageService.SHOW_POINT_CLICK_TOUR);
    await this.runWizardBasedOnPopulation(location, lat, lng, population);
  }

  private async runWizardBasedOnPopulation(location: string, lat: number, lng: number, population: number) {
    // if (showPointClickTour) {
    //   const wizard = new PointClickTourWizard();
    //   await this.wizardRunner.run(wizard).afterClosed().toPromise();
    // }

    if (population > this.populationLimit) {
      await this.runStoreAddWizard(location, lat, lng);
    } else {
      await this.runLowPopulationAlertWizard();
    }
  }

  private async runStoreAddWizard(location: string, lat: number, lng: number) {
    const wizard = new StoreAddWizard();
    wizard.model = {
      location: location,
      lat: lat,
      lng: lng,
      hideActionSpinner: true,
      currentSearchlocation: this.currentSearchlocation
    };
    await this.wizardRunner.run(wizard).afterClosed().toPromise();

    this.toggleDropPin();
    this.showDropPin = true;
  }


  private async runLowPopulationAlertWizard() {
    const wizard = new LowPopulationAlertWizard();
    await this.wizardRunner.run(wizard).afterClosed().toPromise();
    this.toggleDropPin();
    this.showDropPin = true;
  }


  // private addMarker(lat: number, lng: number): void {
  //   const newMarker = new google.maps.Marker({
  //     position: { lat, lng },
  //     map: this.map,
  //     icon: {
  //       url: '/assets/images/location-svg.svg', // Path to your custom icon
  //       scaledSize: new google.maps.Size(40, 40), // Resize the icon if needed
  //       anchor: new google.maps.Point(0, 0) // Center of the image (width/2, height/2)
  //     },
  //     draggable: false
  //   });

  //   // Add the marker to the clusterer if necessary
  //   if (this.markerClusterer) {
  //     this.markerClusterer.addMarker(newMarker);
  //   } else {
  //     // If not using a clusterer, add it directly to the map
  //     newMarker.setMap(this.map);
  //   }
  // }

}
